module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "网站测速",
      "description": "主要衡量网站的速度，评估网站的网页加载时间，并提出相关的网站速度优化建议",
      "pos": "right"
    }
  }), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabData), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "tab-item"
    }, [_c('a', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.curTabId === tab.id
      },
      on: {
        "click": function($event) {
          _vm.curTabId = tab.id
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  })), _c('div', {
    staticClass: "container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curTabId === 'rate'),
      expression: "curTabId === 'rate'"
    }],
    staticClass: "label"
  }, [_vm._v("需诊断的网站URL")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curTabId === 'speed'),
      expression: "curTabId === 'speed'"
    }],
    staticClass: "label"
  }, [_vm._v("需测速的网站URL")]), _c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    attrs: {
      "placeholder": "请输入 URL"
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.submit($event)
      },
      "input": function($event) {
        _vm.inputText = $event
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("测一下")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae893b46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae893b46!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/speed.vue
// module id = 790
// module chunks = 0